<mat-toolbar>
  <img
    src="../../assets/images/header-logo.svg"
    width="90px"
    (click)="gotoLandingPage()"
    style="cursor: pointer;"
  />
</mat-toolbar>
